<template>
    <NUIButton
      :obj="this.print"
      :displayType="'icon'"
    />
</template>

<script>

import NUIButton from '../../nelsonUI/NUIButton.vue';
import {usePrintStore} from '../../../store/PrintStore';

export default {
  data () {
    return {
      print: {
        label: 'Print',
        icon: 'black_print',
        value: 'print',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        func: this.handlePrint,
      }
    };
  },
  methods: {
    handlePrint () {
      usePrintStore().setPrintIsOpen(true);
    }
  },
  components: {
    NUIButton
  }
};
</script>

<style scoped>
.calculations-button {
  width: 100px;
  background-color: yellowgreen;
  cursor: pointer;
}
</style>